export class Paginator {
  current: number;
  total: number;
  title: string;
  steps: Array<{ title: string; skipRules?: Array<(dataStore: Record<string, any>) => boolean>; notEmpty?: boolean }>;
  antSteps: Array<{ title: string }>;
  setCurrent: React.Dispatch<React.SetStateAction<number>>;
  onChangeRule: (dataStore: Record<string, any>, localParamData: Record<string, any>) => void;
  onSubmit: (dataStore: Record<string, any>) => void;

  constructor(setCurrent: React.Dispatch<React.SetStateAction<number>>) {
    this.setCurrent = setCurrent;
    this.current = 0;
    this.total = 0;
    this.steps = [];
    this.antSteps = [];
    this.title = "";
    this.onChangeRule = () => {};
    this.onSubmit = () => {};
  }

  getCurrentStep() {
    return this.steps[this.current];
  }

  stepper(step: number, dataStore: Record<string, any>) {
    this.current += step;
    const currentStep = this.getCurrentStep();
    if (!currentStep) {
      console.error("Invalid step", this.current, step);
      throw new Error();
    }
    const skipRules = currentStep.skipRules;
    if (skipRules?.length) {
      // console.log("RULES", skipRules, currentStep);
      skipRules.some((skipRule) => {
        if (skipRule(dataStore)) {
          this.stepper(step, dataStore);
          return true;
        }
        return false; // Ensures a value is always returned
      });
    }
  }

  forward(dataStore: Record<string, any>) {
    this.stepper(1, dataStore);
    this.setCurrent(this.current);
    
    // Small delay to ensure DOM is updated
    setTimeout(() => {
      const surveyElement = document.getElementById("reactContainer");
      if (surveyElement) {
        surveyElement.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  }

  backward(dataStore: Record<string, any>) {
    this.stepper(-1, dataStore);
    this.setCurrent(this.current);
    
    // Small delay to ensure DOM is updated
    setTimeout(() => {
      const surveyElement = document.getElementById("reactContainer");
      if (surveyElement) {
        surveyElement.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  }

  isEnd(currentPage: number) {
    return currentPage >= this.total - 1;
  }

  isStart(currentPage: number) {
    return currentPage <= 0;
  }

  public createSteps(
    items: Array<{ title: string; skipRules?: Array<(dataStore: Record<string, any>) => boolean>; notEmpty?: boolean }> = []
  ) {
    const steps = [];
    for (let i = 0; i < items.length; i++) {
      const title = items[i]?.title || `Step ${i + 1}`;
      steps.push({ title });
    }
    this.total = items.length;
    this.antSteps = steps;
    this.steps = items;
  }
}
